import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedCompanyFromDomain: {
    selectedUserPeersetName: "select",
    selectedUserPeersetData: [],
    selectedUserPeersetDataNonAgg: [],
  },
  filterTableData: {
    filterTable: [],
  },
  outPutRowId: {
    RowId: "",
  },
  Api: {
    Id: '',
    data: false
  },
  IP: '',
  outputDisplayFormat: "Format1"

};

const combinedSlice = createSlice({
  name: "combined",
  initialState,
  reducers: {
    // Selected Company From Domain Reducers
    setSelectedUserPeersetName: (state, action) => {
      state.selectedCompanyFromDomain.selectedUserPeersetName = action.payload;
    },
    setSelectedUserPeersetData: (state, action) => {
      state.selectedCompanyFromDomain.selectedUserPeersetData = action.payload;
    },
    setSelectedUserPeersetDataNonAgg: (state, action) => {
      state.selectedCompanyFromDomain.selectedUserPeersetDataNonAgg =
        action.payload;
    },

    // Filter Table Data Reducers
    setFilterTable: (state, action) => {
      state.filterTableData.filterTable = action.payload || [];
    },
    addFilterTableItem: (state, action) => {
      const item = action.payload;
      const existingItemIndex = state.filterTableData.filterTable.findIndex(
        (i) => i.DisplayName === item.DisplayName
      );
      if (existingItemIndex === -1) {
        state.filterTableData.filterTable.push(item);
      }
    },
    clearFilterTable: (state) => {
      state.filterTableData.filterTable = [];
    },
    removeFilterTableItem: (state, action) => {
      const itemId = action.payload;
      state.filterTableData.filterTable =
        state.filterTableData.filterTable.filter((item) => item.id !== itemId);
    },
    setOutPutRowId: (state, action) => {
      state.outPutRowId.RowId = action.payload;
    },
    setGetapiId: (state, action) => {
      state.Api.Id = action.payload;
    },
    setAPIData: (state, action) => {
      state.Api.data = action.payload;
    },
    setIPaddress: (state, action) => {
      state.IP = action.payload;
    },
    setOutputFormat: (state, action) => {
      state.outputDisplayFormat = action.payload;
    },
  },
});

export const {
  setSelectedUserPeersetName,
  setSelectedUserPeersetData,
  setSelectedUserPeersetDataNonAgg,
  setFilterTable,
  addFilterTableItem,
  removeFilterTableItem,
  clearFilterTable,
  setOutPutRowId,
  setGetapiId,
  setIPaddress,
  setAPIData,
  setOutputFormat
} = combinedSlice.actions;

export default combinedSlice.reducer;
